import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, Grid, IconButton, Typography, Box, Select, MenuItem, Button } from '@mui/material';
import { WSIcons } from '../../commonFunctions/iIcons';

interface KOTDialogProps {
  open: boolean;
  onClose: () => void;
}

const KOTDialog: React.FC<KOTDialogProps> = ({ open, onClose }) => {
  const [openSecondDialog, setOpenSecondDialog] = useState(false);

  // Function to handle opening of the second dialog
  const handleOpenSecondDialog = () => {
    setOpenSecondDialog(true);
  };

  // Function to handle closing of the second dialog
  const handleCloseSecondDialog = () => {
    setOpenSecondDialog(false);
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        fullWidth={true}
        maxWidth="md"
        PaperProps={{
          style: {
            backgroundColor: 'whitesmoke',
            width: '80vw',
            height: '80vh',
          },
        }}
      >
        <DialogTitle sx={{ backgroundColor: 'green' }}>
          <Grid display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h6" color="white">
              Assign KOT
            </Typography>
            <IconButton onClick={onClose}>
              <WSIcons.CloseIcon sx={{ color: 'white' }} />
            </IconButton>
          </Grid>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 2 }}>
            <Grid item xs={12} sm={6}>
              <Select
                fullWidth
                variant="outlined"
                value=""
                displayEmpty
                onOpen={handleOpenSecondDialog} // Opens the second dialog when down arrow is pressed
                sx={{ backgroundColor: 'white' }}
              >
                {/* Menu items here */}
              </Select>
            </Grid>
          </Grid>
          <Grid container spacing={2} sx={{ mt: 2 }}>
            {/* First Box */}
            <Grid item xs={12} sm={5}>
              <Grid sx={{ border: '1px solid grey', borderRadius: 1, overflow: 'hidden' }}>
                <Grid sx={{ backgroundColor: 'white', padding: 1 }}>
                  <Typography variant="h6">KOT</Typography>
                </Grid>
                <Grid sx={{ padding: 2, height: '20rem' }} />
              </Grid>
            </Grid>

            {/* Icon Container for Vertical Alignment */}
            <Grid
              item
              xs={12}
              sm={2}
              display="flex"
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
            >
              <IconButton  sx={{
                      border: "1px solid #ccc",
                      padding: "1rem",
                      marginRight: "8px",
                      borderRadius: "2px",
                      mb: 2 
                    }}>
                <WSIcons.ChevronRightIcon />
              </IconButton>
              <IconButton sx={{
                      border: "1px solid #ccc",
                      padding: "1rem",
                      marginRight: "8px",
                      borderRadius: "2px",
                    }}>
                <WSIcons.KeyboardArrowLeftIcon  />
              </IconButton>
            </Grid>

            {/* Second Box */}
            <Grid item xs={12} sm={5}>
              <Grid sx={{ border: '1px solid grey', borderRadius: 1, overflow: 'hidden' }}>
                <Grid sx={{ backgroundColor: 'white', padding: 1 }}>
                  <Typography variant="h6">KOT</Typography>
                </Grid>
                <Grid sx={{ padding: 2, height: '20rem' }} />
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
        <Grid item
      sx={{
        backgroundColor: "#333", 
        padding: "1rem",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <Grid container spacing={2} alignItems="center" gap={3}>
        <Grid item>
          <WSIcons.GTranslateIcon sx={{ color: "white" }} />
        </Grid>
        
      </Grid>

        <Button
          variant="contained"
          sx={{
            backgroundColor: "green",
            "&:hover": {
              backgroundColor: "#388e3c",
            },
          }}
        >
          Finish
        </Button>
      </Grid>
      </Dialog>

      {/* Second Dialog that appears above the first one */}
      <Dialog
        open={openSecondDialog}
        onClose={handleCloseSecondDialog}
        PaperProps={{
          style: {
            backgroundColor: 'whitesmoke',
            width: '50vw',
            height: '50vh',
          },
        }}
      >
        <DialogTitle sx={{ backgroundColor: 'green' }}>
          <Grid display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h6" color="white">
              Select Table
            </Typography>
            <IconButton onClick={handleCloseSecondDialog}>
              <WSIcons.CloseIcon sx={{ color: 'white' }} />
            </IconButton>
          </Grid>
        </DialogTitle>
        <DialogContent>
          {/* Content for the second dialog */}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default KOTDialog;
